import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getEvaluations = store => store[NAME].evaluations;
export const getShowRecognitionPoints = store => store[NAME].showRecognitionPoints;
export const getShowSalaryInfo = store => store[NAME].showSalaryInfo;
export const getScoreData = store => store[NAME].scoreData;
export const getSummaryData = store => store[NAME].summaryData;
export const getNpsName = store => store[NAME].npsName;